export class Login{
   
    public UserName : String;
    public Password : String;
    public OldPassword : String;
    public ConfirmPassword : String;
}

export class mUser{
    public Id : Number;
    public IsActive : Boolean = true;
    public UserName : String;
    public Password : String;
    public LastLoginDate : String;
    public Name : String;
    public Email : String;
    public LanguageId : Number;
    public NewPassword: String;
}
export class zRolePageAccess{
    public RoleId : Number;
    public Pages: any = [];
}
export class zMultiUserHandler{
    public TableName : String;
    public RecordId: Number;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/user.model.ts